<template>
  <Modal
    v-model="visible"
    title="选择产品"
    width="1200"
    class="my-modal"
    :mask-closable="false"
    :footer-hide="true"
  >
    <div class="form">
      <div class="input-item">
        <span class="label">产品名称</span>
        <Input
          class="value"
          v-model="searchObj.productName"
          placeholder="请输入"
          clearable
        />
      </div>
      <Button type="primary" @click="queryProductList">查询</Button>
    </div>

    <div class="table-box setTable">
      <loading :isShow="$root.$children[0].isShowLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="sellTypeSlot">
          <div class="sellTypeColumn" v-if="row.sellType">
            <Tag color="blue" v-if="row.sellType.includes('1')">网销</Tag>
            <Tag color="blue" v-if="row.sellType.includes('2')">电销</Tag>
            <Tag color="blue" v-if="row.sellType.includes('3')">经代</Tag>
          </div>
          <div v-else>-</div>
        </template>

        <template slot-scope="{ row }" slot="action">
          <div class="action">
            <a @click="confirmSelect(row)">确认选择</a>
          </div>
        </template>
      </Table>
    </div>

    <div class="pageBox">
      <Page
        :total="total"
        :current="searchObj.pageNo"
        :page-size="searchObj.pageSize"
        show-total
        @on-change="pageChange"
        style="text-align: center"
      />
    </div>
  </Modal>
</template>

<script>
export default {
  props: [],
  components: {},
  data() {
    return {
      visible: false,
      tableData: [],
      columns: [
        {
          title: "产品名称",
          minWidth: 260,
          align: "center",
          key: "productName",
        },
        {
          title: "产品编码",
          minWidth: 80,
          align: "center",
          key: "productCode",
        },
        {
          title: "销售类型",
          minWidth: 100,
          align: "center",
          slot: "sellTypeSlot",
        },
        {
          title: "保险公司",
          minWidth: 100,
          align: "center",
          key: "companyName",
        },
        {
          title: "业务分类",
          minWidth: 280,
          align: "center",
          render(h, params) {
            const themeName = params.row.themeName;
            return <span>{ themeName ? themeName : "-" }</span>;
          },
        },
        {
          title: "供应商",
          minWidth: 100,
          align: "center",
          render(h, params) {
            const source = params.row.source;
            return <span>{ source ? source : '-' }</span>;
          },
        },
        {
          title: "状态",
          minWidth: 80,
          align: "center",
          render(h, params) {
            const publishStatus = params.row.publishStatus;
            return <span>{publishStatus == "1" ? "已下架" : "已上架"}</span>;
          },
        },
        {
          title: "操作",
          minWidth: 80,
          align: "center",
          slot: "action",
        },
      ],
      total: 0,
      searchObj: {
        pageNo: 1,
        pageSize: 10,
      },
    };
  },
  methods: {
    open() {
      this.searchObj.pageNo = 1;
      this.initProductList();
      this.visible = true;
    },

    // 获取列表
    initProductList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: "/buz/productBase/read/choice",
        type: "POST",
        data: this.searchObj,
      }).then((res) => {
        this.total = res.total;
        this.tableData = res.data;
        this.$root.$children[0].isShowLoading = false;
      });
    },

    // 选中产品
    confirmSelect(item) {
      this.$emit('confirm-select', item)
      this.visible = false;
    },

    // 查询
    queryProductList() {
      this.searchObj.pageNo = 1;
      this.initProductList();
    },

    // 分页
    pageChange(pageNo) {
      this.searchObj.pageNo = pageNo;
      this.initProductList();
    },
  },
};
</script>

<style lang="scss" scoped>
.my-modal {
  /deep/ {
    .ivu-modal-body {
      padding-top: 0;
      padding-bottom: 30px;
    }
  }
  .form {
    display: flex;
    align-items: center;
    margin-top: 10px;
    .input-item {
      display: flex;
      align-items: center;
      padding-right: 50px;
    }
    .label {
      min-width: 70px;
    }
    .value {
      width: 300px;
      min-width: 200px;
    }
    /deep/ .add-btn {
      background: #f59045 !important;
      border: none;
    }
  }
  .setTable {
    margin-top: 20px;
    .action {
      font-size: 12px;
    }
  }
  .pageBox {
    margin-top: 20px;
  }
  /deep/ .setTable .ivu-table th .ivu-table-cell {
    font-size: 12px;
    font-weight: bold;
    color: #272933;
  }
  /deep/ .ivu-table-tip {
    font-size: 12px;
  }
}
</style>